/**
 * Global nav: hamburger menu and popover. Open/close and accessibility.
 */

const POPOVER_ID = 'navPopover';
const MENU_BUTTON_ID = 'navMenuButton';

function getPopover() {
  return document.getElementById(POPOVER_ID);
}

function getMenuButton() {
  return document.getElementById(MENU_BUTTON_ID);
}

function isOpen() {
  const popover = getPopover();
  return popover && popover.classList.contains('nav-popover-open');
}

function open() {
  const popover = getPopover();
  const button = getMenuButton();
  if (!popover || !button) return;
  popover.dataset.openedAt = String(Date.now());
  popover.classList.add('nav-popover-open');
  button.setAttribute('aria-expanded', 'true');
}

function close() {
  const popover = getPopover();
  const button = getMenuButton();
  if (!popover || !button) return;
  delete popover.dataset.openedAt;
  popover.classList.remove('nav-popover-open');
  button.setAttribute('aria-expanded', 'false');
}

function toggle() {
  if (isOpen()) close();
  else open();
}

function setupNav() {
  const button = getMenuButton();
  const popover = getPopover();
  const closeBtn = document.getElementById('navPopoverClose');

  if (!button || !popover) return;

  button.addEventListener('click', () => toggle());

  if (closeBtn) closeBtn.addEventListener('click', () => close());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) close();
  });

  popover.addEventListener('click', (e) => {
    if (e.target.closest('a') || e.target.closest('.theme-toggle')) close();
  });

  document.addEventListener('click', (e) => {
    if (!isOpen()) return;
    if (popover.contains(e.target) || button.contains(e.target)) return;
    close();
  });
}

export { setupNav };
